import {TemplateList} from "~/libs/constants/TemplateList"
import type SeoMeta from "~/libs/interfaces/SeoMeta"

export const SeoConfig: Record<TemplateList, SeoMeta> = {
  [TemplateList.BLESK]: {
    title: 'BLESKOVÉ HRY',
    ogTitle: 'Každý den nová šance vyhrát s Výhrou Blesku!',
    description: 'Buďte první, kdo ověří své poštovní směrovací číslo S Výhrou Blesku a získejte hodnotné ceny. Každý den nová šance na výhru!',
    ogDescription: 'Jedno PSČ denně, jeden rychlý výherce. Buďte to právě vy!',
    author: 'CZECH NEWS CENTER a.s.',
    image: '/img/blesk/og-image.png',
    twitterCard: 'summary_large_image',
  },
}